export const LOGO_URL = "https://customer-assets-m6fa6gv7.emergentagent.net/job_social-soiree-studio/artifacts/zf0iplvl_FullLogo%20%281%29.jpg";

export const HERO_VIDEO = "/media/hero-flyover-hd.mp4";
export const HERO_VIDEO_MOBILE = "/media/hero-flyover-sd.mp4";
export const HERO_VIDEO_WEBM = "/media/hero-flyover.webm";

export const MEDIA = {
  hero: "https://images.unsplash.com/photo-1470337458703-46ad1756a187?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxiYXJ0ZW5kZXIlMjBwb3VyaW5nJTIwY29ja3RhaWwlMjBsdXh1cnl8ZW58MHx8fHwxNzg3OTQ2MjU2fDA&ixlib=rb-4.1.0&q=85",
  bartender: "https://images.unsplash.com/photo-1607622750671-6cd9a99eabd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxiYXJ0ZW5kZXIlMjBwb3VyaW5nJTIwY29ja3RhaWwlMjBsdXh1cnl8ZW58MHx8fHwxNzg3OTQ2MjU2fDA&ixlib=rb-4.1.0&q=85",
  grazing: "https://images.unsplash.com/photo-1642643151267-86ee35313758?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NjY2NzN8MHwxfHNlYXJjaHwzfHxjaGFyY3V0ZXJpZSUyMGJvYXJkJTIwZ3JhemluZyUyMHRhYmxlfGVufDB8fHx8MTc4Nzk0NjI1MHww&ixlib=rb-4.1.0&q=85",
  platter: "https://images.unsplash.com/photo-1575177990047-1a6a4d211486?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxjaGFyY3V0ZXJpZSUyMGJvYXJkJTIwZ3JhemluZyUyMHRhYmxlfGVufDB8fHx8MTc4Nzk0NjI1MHww&ixlib=rb-4.1.0&q=85",
};

export const cocktails = [
  {
    id: "smoked-old-fashioned",
    name: "Smoked Pecan Old Fashioned",
    category: "smoke",
    categoryLabel: "Signature Smoke",
    image: "https://images.unsplash.com/photo-1605806629664-1a050df0a913?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjb2NrdGFpbCUyMGFtYmVyJTIwZ2xhc3N8ZW58MHx8fHwxNzg3OTQ2MjUwfDA&ixlib=rb-4.1.0&q=85",
    description: "A crystal tumbler, clear ice sphere, and flamed orange peel built for slow conversation.",
    notes: "Wood smoke · vanilla bean · roasted pecan · toasted citrus",
    spirit: "Small-batch Kentucky rye bourbon",
    glass: "Hand-cut lowball",
    garnish: "Flamed orange + pecan smoke",
  },
  {
    id: "blood-orange-mezcalita",
    name: "Blood Orange & Rosemary Mezcalita",
    category: "agave",
    categoryLabel: "Agave & Citrus",
    image: "https://images.unsplash.com/photo-1626688445658-c948f32d68ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjb2NrdGFpbCUyMGFtYmVyJTIwZ2xhc3N8ZW58MHx8fHwxNzg3OTQ2MjUwfDA&ixlib=rb-4.1.0&q=85",
    description: "A bright, smoky pour with a salt rim that turns the first sip into a ritual.",
    notes: "Smoky agave · blood orange · wild rosemary · black lava salt",
    spirit: "Artisanal Oaxacan mezcal",
    glass: "Faceted coupe",
    garnish: "Torched rosemary + smoked salt",
  },
  {
    id: "midnight-berry-sour",
    name: "Midnight Velvet Berry Sour",
    category: "velvet",
    categoryLabel: "Velvet & Foam",
    image: "https://images.unsplash.com/photo-1621873815234-781259c55de5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjb2NrdGFpbCUyMGFtYmVyJTIwZ2xhc3N8ZW58MHx8fHwxNzg3OTQ2MjUwfDA&ixlib=rb-4.1.0&q=85",
    description: "A deep ruby pour with botanical foam and the texture of an after-dark lounge.",
    notes: "Blackberry reduction · cold-pressed lemon · amaro · silk foam",
    spirit: "Botanical dry gin + blackcurrant amaro",
    glass: "Ribbed vintage highball",
    garnish: "Berry gloss + botanical foam",
  },
  {
    id: "cognac-espresso-velvet",
    name: "Gilded Cognac Espresso Velvet",
    category: "after-dark",
    categoryLabel: "After Dark",
    image: "https://images.unsplash.com/photo-1765130803583-a5de64bbcc70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjb2NrdGFpbCUyMGFtYmVyJTIwZ2xhc3N8ZW58MHx8fHwxNzg3OTQ2MjUwfDA&ixlib=rb-4.1.0&q=85",
    description: "Fresh espresso, VSOP cognac, and a fine dusting of gold for the final act.",
    notes: "Roasted espresso · VSOP cognac · Tahitian vanilla · dark cocoa",
    spirit: "VSOP cognac + artisan coffee liqueur",
    glass: "Nick & Nora coupe",
    garnish: "Golden crema + cocoa dust",
  },
];

export const cocktailFilters = [
  { id: "all", label: "All pours" },
  { id: "smoke", label: "Smoke" },
  { id: "agave", label: "Agave" },
  { id: "velvet", label: "Velvet" },
  { id: "after-dark", label: "After dark" },
];

export const chapters = [
  {
    number: "01",
    title: "The alchemy of the pour",
    tagline: "Beyond bartending — we engineer sensory moments.",
    body: "Every event receives a tailored beverage narrative. From torched herbs and custom dehydrated citrus to cold-pressed botanical syrups, our mixologists craft drinks that command attention and ignite conversation.",
    detail: "Handcrafted syrups · smoked salt rims · clarified infusions",
  },
  {
    number: "02",
    title: "The art of the graze",
    tagline: "Edible centerpieces curated with aesthetic precision.",
    body: "Our charcuterie tables and mobile carts turn the traditional snack table into a decadent work of art. Imported cave-aged cheeses, marbled charcuterie, honeycomb, and seasonal florals create an immersive culinary landscape.",
    detail: "Prosciutto di Parma · truffle pecorino · wild honeycomb",
  },
  {
    number: "03",
    title: "The effortless host",
    tagline: "Full turnkey hospitality so you remain in the celebration.",
    body: "From custom spirits shopping lists and glassware curation to seamless setup and breakdown, Pop Social relieves the host of logistical friction. You sip, savor, and celebrate.",
    detail: "Turnkey logistics · custom shopping guides · dedicated staffing",
  },
];

export const services = [
  {
    id: "foundation",
    eyebrow: "The foundation",
    title: "Standard package",
    price: "$1,400",
    body: "The considered beginning for a polished bar experience, with the essentials handled from arrival to last pour.",
    items: ["One professional bartender", "Standard portable bar", "Cups, straws, cocktail napkins", "Fresh citrus + classic garnishes", "Spirits, wine + mixers shopping list", "Setup and breakdown within 90 minutes of travel"],
  },
  {
    id: "enhancements",
    eyebrow: "The signature layer",
    title: "Mixology enhancements",
    price: "$2–$5 / guest",
    body: "Add the details guests remember: custom menus, premium garnish work, mixers, ice, toasts, and hydration.",
    items: ["Custom three-cocktail menu + print", "Dehydrated fruit + edible flowers", "Full mixers package", "Premium ice service", "Champagne toast experience", "Batched hydration station"],
  },
  {
    id: "charcuterie",
    eyebrow: "The centrepiece",
    title: "Charcuterie cart or table",
    price: "Custom curation",
    body: "Imported charcuterie, artisan cheeses, fresh fruit, warm breads, honeycomb, and gourmet condiments arranged as an edible installation.",
    items: ["Bespoke mobile cart", "Full grazing table installation", "Cocktail-hour crudité", "Grazing boxes for intimate affairs"],
  },
  {
    id: "staffing",
    eyebrow: "The scale",
    title: "Staffing + logistics",
    price: "$175+",
    body: "More guests, more time, or a more ambitious footprint — scaled with transparent fixed rates.",
    items: ["Additional bartender — $175", "Additional portable bar — $200", "Extra service hour — $100 / hour / bar", "Insulated cooler rental — $50"],
  },
];

export const spirits = [
  { id: "vodka", label: "Vodka" },
  { id: "gin", label: "Gin" },
  { id: "tequila", label: "Tequila" },
  { id: "rum", label: "Rum" },
  { id: "whiskey", label: "Whiskey" },
  { id: "bourbon", label: "Bourbon" },
  { id: "scotch", label: "Scotch" },
];

export const serviceStyles = [
  "Signature cocktails + wine & beer",
  "Full custom mixology bar",
  "Beer & wine service",
  "Bar + charcuterie experience",
];

export const calculatorAddons = [
  { id: "custom-menu", label: "Custom cocktail menu + printed cards", shortLabel: "Custom menu", cost: 0, priceLabel: "Included" },
  { id: "premium-garnishes", label: "Premium garnishes + smoked salts", shortLabel: "Premium garnishes", cost: 3, priceLabel: "$3 pp" },
  { id: "mixers", label: "Modern mixology provided", shortLabel: "Mixology", cost: 0, priceLabel: "Free" },
  { id: "ice", label: "Event ice provided", shortLabel: "Ice", cost: 5, priceLabel: "$5 pp" },
  { id: "champagne", label: "Champagne toast + flutes", shortLabel: "Champagne toast", cost: 0, priceLabel: "Free" },
  { id: "hydration", label: "Hydration station", shortLabel: "Hydration station", cost: 0, priceLabel: "Varies" },
  { id: "charcuterie", label: "Mobile charcuterie cart", shortLabel: "Charcuterie cart", cost: 1200, flat: true, priceLabel: "$1,200" },
  { id: "additional-bar", label: "Additional bar", shortLabel: "Additional bar", cost: 500, flat: true, priceLabel: "$500" },
];

export const testimonials = [
  {
    quote: "Pop Social made our waterfront anniversary completely unforgettable. The smoked rosemary old fashioneds and multi-tiered grazing table stole the show.",
    author: "Elena & Marc V.",
    event: "Private estate anniversary · Fort Lauderdale",
  },
  {
    quote: "The team was impeccably dressed, wildly efficient, and the custom cocktail menu was sheer brilliance. Every detail felt intentional.",
    author: "David K.",
    event: "Executive summit · Brickell",
  },
  {
    quote: "From the spirit shopping calculation to the midnight breakdown, the entire experience was flawless. Our guests are still raving about the charcuterie cart.",
    author: "Chloe S.",
    event: "Bespoke wedding celebration · Palm Beach",
  },
];

export const marqueeItems = [
  "Private residential soirées",
  "Luxury wedding receptions",
  "Bespoke smoked cocktails",
  "Artisanal grazing spreads",
  "White-glove bartender staffing",
  "Mobile bar experiences",
  "South Florida hospitality",
];
